import Axios from '../utils/axios-utils';


// get Vehicle Expense Reports
export const getVehicleExpenseReports = async (accountId, from, to, vendorId, userId) => {
    try {
        const params = { from };
        

        // Helper: check if value is null, undefined, or the 1970 fallback date
        const isValidDate = (val) => {
            if (!val) return false;
            const date = val instanceof Date ? val : new Date(val);
            return !isNaN(date.getTime()) && date.getTime() > 0;
        };

        if (isValidDate(to)) params.to = to;
        if (vendorId != null) params.vendorId = vendorId;
        if (userId != null) params.userId = userId;

        const response = await Axios.get(`/accounts/${accountId}/reports/expenses/vehicles`, { params });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Vehicle Expense Reports error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Vehicle Expense Reports failed" }
        };
    }
};


// get Vendor Expense Reports
export const getVendorExpenseReports = async (accountId, from, to, vendorId, userId) => {
    try {
        const params = { from };

        // Helper: check if value is null, undefined, or the 1970 fallback date
       const isValidDate = (val) => {
            if (!val) return false;
            const date = val instanceof Date ? val : new Date(val);
            return !isNaN(date.getTime()) && date.getTime() > 0;
        };

        if (isValidDate(to)) params.to = to;
        if (vendorId != null) params.vendorId = vendorId;
        if (userId != null) params.userId = userId;

        const response = await Axios.get(`/accounts/${accountId}/reports/expenses/vendors`, { params });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Vendor Expense Reports error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Vendor Expense Reports failed" }
        };
    }
};


// get Category Expense Reports
export const getCategoryExpenseReports = async (accountId, from, to, vendorId, userId) => {
    try {
        const params = { from };

        // Helper: check if value is null, undefined, or the 1970 fallback date
       const isValidDate = (val) => {
            if (!val) return false;
            const date = val instanceof Date ? val : new Date(val);
            return !isNaN(date.getTime()) && date.getTime() > 0;
        };

        if (isValidDate(to)) params.to = to;
        if (vendorId != null) params.vendorId = vendorId;
        if (userId != null) params.userId = userId;

        const response = await Axios.get(`/accounts/${accountId}/reports/expenses/category`, { params });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get category Expense Reports error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get category Expense Reports failed" }
        };
    }
};